export default "__VITE_ASSET__jKp2GOdF__"